module.exports = __webpack_public_path__ + "static/media/IMG_0965.fedd5c40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/makeup_hair/IMG_0965.jpg
// module id = 372
// module chunks = 0